export interface PlaceholderItem {
    id: string;
    placeholder: true;
    [key: string]: unknown;
}

function usePlaceholderItems(count, props = null): PlaceholderItem[] {
    return [...Array(count).keys()].map((index) => ({
        id: `${index}`,
        placeholder: true,
        ...props,
    }));
}

export default usePlaceholderItems;
